import React, { useState, useCallback } from 'react';
import { prepareLogData } from '../../../components/Util';
import {
    TranslatedString,
    InputField,
    PrimaryButton,
} from '@bosch/bt-ui';

import './PathfinderUpdate.css';
import withErrorHandler from '../../../components/ErrorHandler';
import RadioOptions from '../../sim-activation-detail-page/RadioComponent/RadioOptions';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useNavigate } from 'react-router-dom';

const PathfinderUpdate = (props) => {
    const {
        token,
        isLoggedIn,
        searchPhysicalPanelId,
        setSearchPhysicalPanelId,
        physicalPanelIdErrorMsg,
        setPhysicalPanelIdErrorMsg,
        setPathfinderUpdateStatus,
        setPathfinderInfoExternalResult
    } = props;

    const [env, setEnv] = React.useState('prod'); // prod, test, dev
    const [openConfirm, setConfirmOpen] = useState(false);
    const onOpenModal = () => setConfirmOpen(true);
    const navigate = useNavigate();

    const onFormSubmit = useCallback(
        async () => {
            const data = prepareLogData(token, 'Panel_Environment', 'Panel Environment->Update panel button: ' + searchPhysicalPanelId + ', ' + env);
            if (token?.token) {
                if(isLoggedIn()) {
                    const updatePathfinderBody = {
                        'Env': env,
                    };

                    const response = await fetch(SUPPORTCONSOLE_API_URL + '/api/panelenvironment/v1/' + encodeURIComponent(searchPhysicalPanelId) + '/pathfinder', {
                        method: 'PUT',
                        headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token.token
                        },
                        body: JSON.stringify(updatePathfinderBody)
                    })
                    setPathfinderUpdateStatus(response?.status);
                    setConfirmOpen(false);
                    setPathfinderInfoExternalResult(null);

                    // Add activity log
                    fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token.token
                        },
                        body: JSON.stringify(data)
                    })	
                }
                else {
                    navigate('/');
                }
            }
        },
        [searchPhysicalPanelId, env, token.token, isLoggedIn, navigate]
    );

    return (
        <div id='pathfinder-update'>
            <div className='pathfinder-update-option'>
                <div className="Input-field">
                    <TranslatedString stringId="physical-id" />:
                    <InputField
                        inputType="text"
                        fieldName="physicalId"
                        label="Physical ID"
                        validationError={physicalPanelIdErrorMsg}
                        onValidationError={(update) => {
                            setPhysicalPanelIdErrorMsg(update.value);
                        }}
                        htmlAttributes={{
                            onChange: (update) => setSearchPhysicalPanelId(update.value),
                            value: searchPhysicalPanelId,
                            pattern: '(\{)?[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}(\})?',
                            title: 'Physical Id is invalid'
                        }}
                    />

                    <PrimaryButton
                        onClick={onOpenModal}
                        disabled={searchPhysicalPanelId.length == 0 || !!physicalPanelIdErrorMsg}
                    >
                        <TranslatedString stringId="button-update"/>
                    </PrimaryButton>
                </div>
            
                <div className='panel-radio-options'>
                    <TranslatedString stringId="point-panel-to" />:
                    <RadioOptions
                        label="PROD"
                        value={env === 'prod'}
                        onChange={() => {setEnv('prod')}}
                    />
                    <RadioOptions
                            label="TEST"
                            value={env === 'test'}
                            onChange={() => {setEnv('test')}}
                    />
                    <RadioOptions
                            label="DEV"
                            value={env === 'dev'}
                            onChange={() => {setEnv('dev')}}
                    /> 
                </div>
                <div>
                    <TranslatedString stringId="note-pathfinder-helper" />
                </div>                   
            </div>
            <ConfirmDialog openConfirm={openConfirm} descTranslatedId={'pathfinder-update-warning'} setConfirmOpen={setConfirmOpen} onConfirm={onFormSubmit} />
        </div>
    );
};

export default withErrorHandler(React.memo(PathfinderUpdate));